import { useQuery } from '@tanstack/react-query'
import { minutesToMilliseconds } from 'date-fns'
import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'
import { useFirebaseUser } from '@/hooks/useFirebaseUser/useFirebaseUser'
import authenticationService from '@/services/authentication/authentication'
import { GetV1UsersMeResponse } from '../client'
import { getV1UsersMeOptions } from '../client/@tanstack/react-query.gen'

export type UserType = GetV1UsersMeResponse

export const useMe = (enabled = true) => {
  const token = useFirebaseToken()
  const { isLoggedIn, reloadUser } = useFirebaseUser()

  return useQuery({
    ...getV1UsersMeOptions(),
    enabled: enabled && !!token,
    refetchInterval: minutesToMilliseconds(60),
    refetchOnWindowFocus: 'always',
    retry: count => {
      if (isLoggedIn && count === 0) {
        reloadUser()

        return true
      }

      authenticationService.signOut()

      return false
    },
  })
}
